'use client';
import { css } from 'styled-system/css';

// category 由呼叫端的 `view === ViewEnum.galaxy ? 'side-category' : styles.category` 三元運算子二選一，
// 只會在 mars 時套用這個 class，不需要 base:none fallback
export const styles = {
	category: css({
		display: 'flex',
		position: 'relative',
		alignSelf: 'flex-start',
		gap: '6px',
		padding: '12px 0',
		margin: '0 15px',
		borderBottom: '1px solid',
		borderColor: 'black.5',
	}),
	// data-selected 由呼叫端的 <Button data-selected={...}> 自己帶，用 &[data-selected=true] 在同一個 class 內處理選取態，
	// 不要拆成 button/buttonSelected 兩個 class 疊加——兩者都設了 color，疊加後誰贏要看 PandaCSS 產生順序，不保證正確
	button: css({
		flex: 1,
		padding: '9px 6px',
		gap: '6px',
		fontSize: '12px',
		color: 'black.2',
		'&[data-selected=true]': {
			border: '1px solid',
			borderColor: 'brand.500_light',
			color: 'brand.500_light',
			backgroundColor: 'category.buttonSelectedBg',
		},
	}),
	// [data-selected=true]>& 對應父層 Button 自己的 data-selected 屬性，同上，不要拆成兩個 class
	buttonText: css({
		textTransform: 'uppercase',
		'[data-selected=true]>&': {
			color: 'black.1',
			fontWeight: '700',
		},
	}),
}